<template>
  <div class="modal fade" id="addDebtWriteOff" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div v-if="customer" class="row">
              <div class="col-10 col-sm-11 my-auto">
                <h5
                  class="modal-title font-weight-bold"
                  id="addDebtWriteOffLabel"
                >Debt Write-Off - {{customer.CustomerName + ' ( ' + customer.CustomerReference + ' )'}}</h5>
              </div>
              <div class="col-2 col-sm-1 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          id="closeDebtWriteOff"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form @submit.prevent="submit">
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-xl-12">
                  <div v-if="salesTransactions && salesTransactions.length > 0">
                    <div class="row">
                      <div class="col-12 my-auto">
                        <div class="table-div mt-3">
                          <b-table
                            responsive
                            fixed
                            striped
                            ref="salesTransactionsTable"
                            class="table-scroll tbl-sml"
                            :items="salesTransactions"
                            :fields="salesTransactionFields"
                          >
                            <template slot="HEAD_Select">
                              <span class="d-inline">
                                <label class="form-check-label radio_style">
                                  <input
                                    type="checkbox"
                                    class="form-check-input radio_style"
                                    v-model="allSelected"
                                    @click="selectAll"
                                  />
                                  <span class="default"></span>
                                </label>
                              </span>
                            </template>

                            <template slot="Select" slot-scope="row">
                              <div>
                                <span class="d-inline">
                                  <label class="form-check-label radio_style">
                                    <input
                                      v-model="row.item._rowSelected"
                                      type="checkbox"
                                      class="form-check-input radio_style"
                                      @click="onRowSelected(row.item, row.index)"
                                      :disabled="(!row.item._rowSelected && row.index != selected.length) || (row.item._rowSelected && row.index != (selected.length - 1))"
                                    />
                                    <span class="default"></span>
                                  </label>
                                </span>
                              </div>
                            </template>

                            <template slot="Description" slot-scope="data">{{data.item.Description}}</template>

                            <template slot="Type" slot-scope="data">{{data.item.Type}}</template>

                            <template slot="Created" slot-scope="data">
                              <!-- This is the TaxPoint such as draft, on hold or billed -->
                              {{data.item.Created | moment('DD.MM.YY')}}
                            </template>

                            <template
                              slot="Age"
                              slot-scope="data"
                            >{{diff(data.item.Created) | suffix}}</template>

                            <template
                              slot="InvoiceTotal"
                              slot-scope="data"
                            >{{data.item.Debit | currency}}</template>

                            <template
                              slot="AmountPaid"
                              slot-scope="data"
                            >{{data.item.Debit - data.item.Outstanding | currency}}</template>

                            <template
                              slot="Outstanding"
                              slot-scope="data"
                            >{{data.item.Outstanding | currency}}</template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-5">
                        <p class="d-inline-block my-auto">
                          <label for="exampleFormControlTextarea6" class="mb-0">Amount to write off</label>
                        </p>
                        <div class="form-group">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon1">£</span>
                            </div>
                            <input
                              type="number"
                              step=".01"
                              class="prefix form-control"
                              v-model="writeOffAmount"
                              placeholder="Eg: 10.00"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-7">
                        <p class="d-inline-block my-auto">Reason</p>
                        <b-form-select class="mb-3" v-model="writeOffReason">
                          <option :value="null"></option>
                          <option
                            v-for="(reason, index) in writeOffReasons"
                            :key="index"
                            :value="reason"
                          >{{reason}}</option>
                        </b-form-select>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <b-btn
                          role="button"
                          class="btn btn-hc float-right"
                          @click="writeOffDebt"
                          :disabled="submitStatus == 'PENDING'"
                        >
                          Write Off
                          Debt
                        </b-btn>
                      </div>
                    </div>
                  </div>

                  <div class="row pb-4" v-else>
                    <div class="col-12">
                      <div class="h-100">
                        <div class="d-flex h-100 justify-content-center align-items-center mt-4">
                          <img
                            src="@/assets/img/tick_selector.png"
                            class="img-fluid d-inline-block"
                            alt
                          />
                          <p
                            class="d-inline-block my-auto pl-2"
                          >No outstanding debt for this account.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { _ } from "underscore";
import _filters from "@/mixins/filters.js";

export default {
  mixins: [_filters],
  data() {
    return {
      submitStatus: null,
      salesTransactionFields: {
        Select: {
          label: "Select",
          class: "text-center col-1",
        },
        Description: {
          label: "Description",
        },
        Type: {
          label: "Type",
        },
        Created: {
          label: "Tax Point",
        },
        Age: {
          label: "Age (Days)",
        },
        InvoiceTotal: {
          label: "Invoice Total",
        },
        AmountPaid: {
          label: "Paid",
        },
        Outstanding: {
          label: "Outstanding",
        },
      },
    };
  },
  computed: {
    customer() {
      return this.$store.state.customers.customer;
    },
    userEmail() {
      return this.$auth.decodedToken.payload.sub;
    },
    ledger() {
      return this.$store.state.finances.ledger;
    },
    salesTransactions() {
      return _.sortBy(
        _.filter(
          _.where(this.ledger, {
            Category: "Sales",
          }),
          function(transaction) {
            return (
              transaction.Outstanding > 0 && transaction.hasOwnProperty("Debit")
            );
          }
        ),
        "Created"
      );
    },
    reasonRequired() {
      return this.$config.honeycomb.writeOffs.writeOffReasonRequired;
    },
    writeOffReasons() {
      return this.$config.honeycomb.writeOffs.writeOffReasons;
    },
    totalOutstanding() {
      var total = 0;
      this.salesTransactions.forEach((transaction) => {
        total += transaction.Outstanding;
      });
      return total;
    },
    writeOffAmount: {
      get() {
        return this.$store.state.finances.writeOffAmount;
      },
      set(amount) {
        this.$store.commit("updateWriteOffAmount", amount);
      },
    },
    writeOffReason: {
      get() {
        return this.$store.state.finances.writeOffReason;
      },
      set(reason) {
        this.$store.commit("updateWriteOffReason", reason);
      },
    },
    selected: {
      get() {
        return this.$store.state.finances.selectedForWriteOff;
      },
      set(selected) {
        this.$store.commit("updateSelectedForWriteOff", selected);
      },
    },
    allSelected: {
      get() {
        return this.$store.state.finances.allSelectedForWriteOff;
      },
      set(bool) {
        this.$store.commit("updateAllSelectedForWriteOff", bool);
      },
    },
  },
  methods: {
    onRowSelected(item, index) {
      if (index == this.selected.length && !item._rowSelected) {
        this.selected.push(item);
        this.allSelected = false;
        if (this.selected.length == this.salesTransactions.length) {
          this.allSelected = true;
        }
        this.$set(item, "_rowSelected", true);
        this.calculateWriteOffAmount();
        return;
      }
      if (index == this.selected.length - 1 && item._rowSelected) {
        this.selected.splice(index, 1);
        this.allSelected = false;
        this.$set(item, "_rowSelected", false);
        this.calculateWriteOffAmount();
        return;
      }
    },
    selectAll() {
      this.selected = [];
      if (!this.allSelected) {
        this.allSelected = true;
        this.salesTransactions.forEach((transaction) => {
          this.selected.push(transaction);
          this.$set(transaction, "_rowSelected", true);
        });
        this.calculateWriteOffAmount();
        return;
      }
      if (this.allSelected) {
        this.allSelected = false;
        this.salesTransactions.forEach((transaction) => {
          this.$set(transaction, "_rowSelected", false);
        });
        this.calculateWriteOffAmount();
        return;
      }
    },
    calculateWriteOffAmount() {
      var total = 0;
      this.selected.forEach((transaction) => {
        total += transaction.Outstanding;
      });
      return (this.writeOffAmount = total.toFixed(2));
    },
    diff(date) {
      return moment().diff(date, "days");
    },
    writeOffDebt() {
      if (this.selected.length == 0) {
        this.$snotify.warning(
          "Please select at least one transaction to be written off."
        );
      }
      if (this.writeOffAmount > this.totalOutstanding) {
        this.$snotify.warning(
          "The amount to write off must not be greater than the total outstanding balance."
        );
      }
      if (!this.writeOffAmount || this.writeOffAmount == 0) {
        this.$snotify.warning("Please provide an amount to write off.");
      }
      if (this.reasonRequired && !this.writeOffReason) {
        this.$snotify.warning("Please select a reason for the debt write-off.");
      }
      if (
        this.selected.length > 0 &&
        this.writeOffAmount <= this.totalOutstanding &&
        this.writeOffAmount > 0 &&
        ((this.reasonRequired && this.writeOffReason) || !this.reasonRequired)
      ) {
        this.submitStatus = "PENDING";
        this.writeOffAmount = parseFloat(this.writeOffAmount).toFixed(2);
        this.selected.forEach((transaction) => {
          var amountToReverse = this.writeOffAmount;

          if (transaction.Outstanding <= this.writeOffAmount)
            amountToReverse = transaction.Outstanding;

          if (this.writeOffAmount > transaction.Debit)
            amountToReverse = transaction.Debit;

          amountToReverse = parseFloat(amountToReverse).toFixed(2);

          this.writeOffAmount -= amountToReverse;

          if (this.writeOffAmount == 0) this.writeOffAmount = null;

          this.$http
            .post(
              "https://" +
                this.$config.honeycomb.moneybot.domain +
                "/api/v1/salesTransactions/" +
                transaction.TransactionId +
                "/writeoff",
              {
                AmountToReverse: amountToReverse,
                CreatedBy: this.userEmail,
                RelatedTransactionId: transaction.TransactionId,
                Memo: this.writeOffReason,
                WriteOffOrBack: true,
              },
              {
                withCredentials: true,
              }
            )
            .then(() => {
              this.$snotify.success(
                `${transaction.Description} has been written off.`
              );
            })
            .catch((error) => {
              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                this.submitStatus = "ERROR";
                this.$snotify.error(
                  error.response.data.MoreInformation[0].Error,
                  {
                    timeout: 0,
                    closeOnClick: true,
                  }
                );
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                this.submitStatus = "ERROR";
                this.$snotify.error("No response recieved.", {
                  timeout: 0,
                  closeOnClick: true,
                });
              } else {
                // Something happened in setting up the request that triggered an Error
                this.submitStatus = "ERROR";
                this.$snotify.error(error.message, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            });
        });
        setTimeout(() => {
          this.submitStatus = "OK";
          this.$store.dispatch("getLedger");
          this.$store.dispatch("getSalesTransactions");
          this.writeOffAmount = null;
          this.writeOffReason = null;
          this.allSelected = false;
          this.selected = [];
        }, 1800);
      }
    },
  },
};
</script>
